import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(1),
    },
    actionContainer: {
      display: 'flex',
      alignItems: 'center',

      '& > * + *': {
        marginLeft: theme.spacing(1),
      },
    },
    actionButton: {
      minWidth: 'fit-content',
      color: theme.palette.text.secondary,
    },
  }),
);
